export const noSupportEpUserUtil = userEntitlements => {
  return userEntitlements.epSupport &&
  (!userEntitlements.highestLevelSupportBenefitFeature === '' ||
  !userEntitlements?.highestLevelSupportBenefitFeature);
}
